// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--6-1!../../node_modules/postcss-loader/lib/index.js??ref--6-2!./style.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("c9a3682e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/indexIcon-1/style.css
// module id = Uqf4
// module chunks = 71